<template>
    <div class="layout">
        <div class="layout__header">
            <h3>Logs</h3>
        </div>
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>Proceso</th>
                        <th>Tipo</th>
                        <th>Motivo</th>
                        <th>Usuario</th>
                        <th>Fecha</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-show="logs.length === 0">
                        <td colspan="5">
                            <strong>No hay logs.</strong>
                        </td>
                    </tr>
                    <tr v-for="(log, index) in logs" :key="index">
                        <td>{{ log.descripcion_estado }}</td>
                        <td>{{ log.tipo }}</td>
                        <td>{{ log.motivo }}</td>
                        <td>{{ log.usuario.nombre }}</td>
                        <td>{{ log.created_at }}</td>
                    </tr>
                </tbody>
            </table>    
        </div>
        <div class="modal-buttons">
            <button type="button" @click="$emit('cerrar')" class="btn-danger btn--text"><i class="fa fa-ban"></i><span>Cerrar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        number : {
            type : String,
            required : true
        }
    },
    mounted : function () {
        let that = this;
        axios.get(url + '/notificaciones/' + this.number).then(function (response) {
            that.logs = response.data;
        });
    },
    data : function () {
        return {
            logs : []
        };
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/inspeccion/ReporteLogs.vue